
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumeric]'
})
export class NumericDirective {

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow special keys like Backspace, Delete, Arrow keys
    if (
      [46, 8, 9, 27, 13, 110, 190].indexOf(event.keyCode) !== -1 ||
      // Allow Ctrl+A/Ctrl+C/Ctrl+V for copying and pasting
      (event.keyCode === 65 && event.ctrlKey === true) ||
      (event.keyCode === 67 && event.ctrlKey === true) ||
      (event.keyCode === 86 && event.ctrlKey === true) ||
      // Allow Ctrl+Z for undoing
      (event.keyCode === 90 && event.ctrlKey === true)
    ) {
      return;
    }

    // Ensure that the input is a number
    if (
      event.shiftKey ||
      (event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105)
    ) {
      event.preventDefault();
    }
  }
}

